import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { SignUpRequest, SignUpResponse } from "../domain/sign-up.domain";
import { SignInModel, SignInResponse } from "../domain/sign-in.domain";
import { SessionResult } from "../domain/session.domain";
import { UserStore } from "../../../libs/store/user.store";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private readonly apiUrl = `${environment.apiUrl}/api/auth`;

  http = inject(HttpClient);
  userStore = inject(UserStore);

  signUp(request: SignUpRequest) {
    return this.http.post<SignUpResponse>(`${this.apiUrl}/sign-up/email`, request);
  }

  signIn(request: SignInModel) {
    return this.http.post<SignInResponse>(`${this.apiUrl}/sign-in/email`, request);
  }

  getSession() {
    return this.http.get<SessionResult>(`${this.apiUrl}/get-session`);
  }

  signOut() {
    return this.http.post(`${this.apiUrl}/sign-out`, {});
  }

  changePassword(
    currentPassword: string,
    newPassword: string,
    revokeOtherSessions: boolean = false
  ) {
    return this.http.post(`${this.apiUrl}/change-password`, {
      currentPassword,
      newPassword,
      revokeOtherSessions
    });
  }
}
